import React, { useState, useCallback, useEffect } from "react";
import MuiAlert from "@mui/material/Alert";
import { Snackbar as MUISnackbar } from "@mui/material";
import { useLocation } from "react-router-dom";

export function usePopupNotification() {
  const [isOpen, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [type, setType] = useState("");
  const [autoHideDuration, setAutoHideDuration] = useState(6000);
  const location = useLocation();

  const openDefault = () => {
    setOpen(true);
  };

  const openSuccess = useCallback((messageMsg, autoHideDuration) => {
    console.log("OPEN S_UCCESS CALLED");
    if (autoHideDuration != null) {
      setAutoHideDuration(autoHideDuration);
    }
    setMessage(messageMsg);
    setType("success");
    setOpen(true);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location]);

  /*
  const openSuccess = (messageMsg, autoHideDuration) => {
    if (autoHideDuration != null) {
      setAutoHideDuration(autoHideDuration);
    }
    setMessage(messageMsg);
    setType("success");
    setOpen(true);
  };*/

  const openError = (errorMsg, autoHideDuration) => {
    if (autoHideDuration != null) {
      setAutoHideDuration(autoHideDuration);
    }
    setMessage(errorMsg);
    setType("error");
    setOpen(true);
  };

  const openInfo = (infoMsg, autoHideDuration) => {
    if (autoHideDuration != null) {
      setAutoHideDuration(autoHideDuration);
    }
    setMessage(infoMsg);
    setType("info");
    setOpen(true);
  };

  const close = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const PopupNotification = useCallback(() => {
    return (
      <Snackbar
        message={message}
        type={type}
        isOpen={isOpen}
        close={close}
        autoHideDuration={autoHideDuration}
      />
    );
  }, [autoHideDuration, isOpen, type, message]);

  return {
    openDefault,
    openSuccess,
    openError,
    openInfo,
    PopupNotification,
  };
}

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Snackbar({ type, message, isOpen, close, autoHideDuration }) {
  return (
    <MUISnackbar
      open={isOpen}
      autoHideDuration={autoHideDuration}
      onClose={close}
      anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
    >
      <Alert onClose={close} severity={type} sx={{ width: "100%" }}>
        {message.split("\n").map((error, index) => (
          <div key={index}>{error}</div>
        ))}
      </Alert>
    </MUISnackbar>
  );
}
